<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref, type PropType, nextTick } from "vue"

const props = defineProps({
  duration: {
    type: Number,
    default: 300
  },
  events: {
    type: Array as PropType<any[]>,
    default: (): any[] => ["mousemove", "keypress"]
  },
  loop: {
    type: Boolean,
    default: false
  },
  reminders: {
    type: Array as PropType<number[]>,
    default: (): number[] => []
  },
  wait: {
    type: Number,
    default: 0
  }
})
const display = ref<string>("")
const timer = ref<number | undefined>(undefined)
const start = ref<number>(0)
const counter = ref<number | undefined>(undefined)
const diff = ref<number>(0)
const minutes = ref<string>("")
const seconds = ref<string>("")

const emit = defineEmits(["idle", "remind"])

const setDisplay = () => {
  // seconds since start
  diff.value = props.duration - (((Date.now() - start.value) / 1000) | 0)
  if (diff.value < 0 && !props.loop) {
    return
  }
  shouldRemind()

  // bitwise OR to handle parseInt
  const minute = (diff.value / 60) | 0
  const second = diff.value % 60 | 0

  minutes.value = `${minute < 10 ? "0" + minute : minute}`
  seconds.value = `${second < 10 ? "0" + second : second}`

  display.value = `${minutes.value}:${seconds.value}`
}
const shouldRemind = () => {
  if (props.reminders.length > 0) {
    if (props.reminders.includes(diff.value)) {
      remind()
    }
  }
}
const countdown = () => {
  setDisplay()

  if (diff.value <= 0) {
    clearTimer(props.loop)
  }
}
const idle = () => {
  emit("idle")
}
const remind = () => {
  emit("remind", diff)
}
const setTimer = () => {
  timer.value = window.setInterval(idle, props.duration * 1000)
  counter.value = window.setInterval(countdown, 1000)
}
const clearTimer = (loop = false) => {
  window.clearInterval(timer.value)
  window.clearInterval(counter.value)
  if (loop) {
    start.value = Date.now()
    diff.value = 0
    setDisplay()
    setTimer()
  }
}
onMounted(() => {
  setTimeout(() => {
    start.value = Date.now()

    setDisplay()
    nextTick(() => {
      setTimer()
      for (let i = props.events.length - 1; i >= 0; i -= 1) {
        window.addEventListener(props.events[i], clearTimer)
      }
    })
  }, props.wait * 1000)
})
onBeforeUnmount(() => {
  clearInterval(timer.value)
  clearInterval(counter.value)
  for (let i = props.events.length - 1; i >= 0; i -= 1) {
    window.removeEventListener(props.events[i], clearTimer)
  }
})
</script>

<template>
  <div class="v-idle">
    {{ display }}
  </div>
</template>

<style scoped></style>
